import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "bulk-option-selector",
  class BulkOptionSelector extends WYATTElement {
    connectedCallback() {
      this.selector = `[data-summary="${this.config.id}"]`;
      this.summary = this.closest(this.selector);
      this.optionSelectors = this.querySelectorAll("[data-option-selector]");
      this.boundHandleChange = this.handleChange.bind(this);

      if (this.optionSelectors.length > 0) {
        this.optionSelectors.forEach((elem) => {
          elem.addEventListener("change", this.boundHandleChange);
        });
      }
    }

    disconnectedCallback() {
      if (this.optionSelectors?.length > 0) {
        this.optionSelectors.forEach((elem) => {
          elem.removeEventListener("change", this.boundHandleChange);
        });
      }
      super.disconnectedCallback();
    }

    handleChange(event) {
      const { target } = event;
      const { selectedIndex, options } = target;
      const selectedOption = options[selectedIndex];

      if (selectedOption) {
        const { url } = selectedOption.dataset;
        this.getProductSummary(url);
      }
    }

    async getProductSummary(url) {
      try {
        const response = await fetch(`${url}&view=bulk-summary`);
        const htmlString = await response.text();
        const parser = new DOMParser();
        const dom = parser.parseFromString(htmlString, "text/html");
        const newContent = dom.querySelector(this.selector);
        this.updateDOM.replaceWith(this.summary, newContent);
      } catch (error) {
        window.console.error(error);
      }
    }
  },
);
